<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :hide-title="hideTitle" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :card-height="cardHeight" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'cardHeight',
            'isHover',
            'hideTitle'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                contactForm: () => import('../forms/ContactForm'),
                fields: [
                    { type: 'contact', value: 'contact', contactField: 'contactId', rules: { name: v => !!v || 'Name is required', emailAddress: v => !!v || 'Email is required' }, noEditEmailAddress: !this.hasRole('Admin') },
                    { type: 'text', text: 'Exemplar Global Number', value: 'exemplarGlobalNumber', rules: [v => !!v || 'Exemplar Global Number is required', v => !(v && v.length > 50) || 'Exemplar Global Number must be less than 50 characters'], isRequired: true, maxLength: 50 },
                ],
                apiMethod: 'Auditors',
                formTitle: 'Auditor',
            }
        }
    };
</script>
